export class SpotLayer extends ol.layer.Vector {
	constructor(options){
		//options.source = new ol.source.Vector();
		super(options);
	}
	
	getFeatureByName(name){
		//console.log('!!!');
		var features = this.getSource().getFeatures();
		for (var i = 0; i < features.length; i++){
			if(features[i].get('name') === name){
				return features[i];
			}
		}
	}
	
	getLoadingHtml(gif='loading3'){
		var result = '<div class="loading '+gif+'"></div>';
		return result;	
	};

}